export default "__VITE_ASSET__yZAhUxhW__"